
import { TasksKeys } from '@/i18n/types';

export const tasks: Record<TasksKeys, string> = {
  addTask: 'Añadir Tarea',
  taskTitle: 'Título de la Tarea',
  taskDescription: 'Descripción de la Tarea',
  dueDate: 'Fecha Límite',
  priority: 'Prioridad',
  high: 'Alta',
  medium: 'Media',
  low: 'Baja',
  status: 'Estado',
  complete: 'Completada',
  incomplete: 'Incompleta',
  inProgress: 'En Progreso',
  taskAdded: 'Tarea Añadida',
  taskUpdated: 'Tarea Actualizada',
  taskDeleted: 'Tarea Eliminada',
  confirmDeleteTask: 'Confirmar Eliminar Tarea',
  assign: 'Asignar',
  taskDetails: 'Detalles de la Tarea',
  taskManagement: 'Gestión de Tareas',
  taskDesc: 'Administra tus tareas y utiliza la técnica Pomodoro para mantener el enfoque.',
  tasks: 'Tareas',
  taskStats: 'Estadísticas de Tareas',
  gamification: 'Gamificación',
  points: 'Puntos',
  streak: 'Racha',
  achievements: 'Logros',
};
